/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsflagshareddomain3Inputs */

const en_signupsflagshareddomain3 = /** @type {(inputs: Signupsflagshareddomain3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared email domain`)
};

const de_signupsflagshareddomain3 = /** @type {(inputs: Signupsflagshareddomain3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleiche E-Mail-Domain`)
};

/**
* | output |
* | --- |
* | "Shared email domain" |
*
* @param {Signupsflagshareddomain3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsflagshareddomain3 = /** @type {((inputs?: Signupsflagshareddomain3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsflagshareddomain3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsflagshareddomain3(inputs)
	return de_signupsflagshareddomain3(inputs)
});
export { signupsflagshareddomain3 as "signupsFlagSharedDomain" }